/**
 * Internal column ID for the primary row action column.
 * This column typically contains expand buttons, but may also contain
 * checkboxes for nested rows when selection is enabled.
 */
export const INTERNAL_ROW_ACTION_PRIMARY_COLUMN_ID =
  "a2-table-internal-row-action-primary";

/**
 * Internal column ID for the secondary row action column.
 * This column contains checkboxes for row selection when enabled.
 * For nested rows, this column renders nothing (selection is handled
 * in the primary action column instead).
 */
export const INTERNAL_ROW_ACTION_SECONDARY_COLUMN_ID =
  "a2-table-internal-row-action-secondary";
